var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","overflow":"hidden"}},[_c('LiveTitle'),_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }